import { Component } from '@angular/core';

@Component({
  selector: 'b4a-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {}



// WEBPACK FOOTER //
// ./src/app/app.component.ts